<template>
  <div class="preview_box">
    <div class="phone_wrap">
      <div class="phone" :style="activityBgImg">
        <div class="header">
          <img
            src="https://cdn-image.yucrm.cn/images/tb/funGamesImg/header.png"
            width="300px"
          />
        </div>
        <div class="intermediate">
          <div class="music_box">
            <img :src="musicImgUrl" width="25px" height="25px" />
          </div>
          <div class="content">
            <div class="logo_box">
              <img
                v-if="viewModelInfo.brandLogoImg"
                :src="viewModelInfo.brandLogoImg"
                alt=""
                width="80px"
                height="40px"
              />
            </div>
            <div class="progressBar_box">
              <div class="progressBar" :style="progressBarStyle1">
                <div class="progress" :style="progressBarStyle2"></div>
              </div>
              <div class="gift_box">
                <div class="gift">
                  <img
                    class="giftImage"
                    src="https://cdn-image.yucrm.cn/images/tb/funGamesImg/gift.png"
                    alt=""
                  />
                  <div class="gift_text">还差xxx分</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="gameContent">
          <div class="gameGuideArea">
            <div
              class="gameGuideAreaBg"
              :style="gameGuideAreaStyle"
              v-if="this.viewModelInfo.holeImg"
            >
              <img
                class="showPrize"
                src="https://cdn-image.yucrm.cn/images/tb/funGamesImg/showPrize.png"
                alt=""
              />
              <div class="countDown">倒计时：{{ formattedTime }}</div>
            </div>
          </div>
          <div class="grabPrize_box">
            <img
              v-if="
                this.viewModelInfo.holeImg && this.viewModelInfo.activityBgImg
              "
              class="grabPrizeImage"
              src="https://cdn-image.yucrm.cn/images/tb/funGamesImg/grabPrize.png"
              alt=""
            />
          </div>
          <div class="grabPrize_btn" :style="grabPrizeBtnBg">
            点击抓取
          </div>
          <div
            class="score_box"
            v-if="
              this.viewModelInfo.holeImg && this.viewModelInfo.activityBgImg
            "
          >
            <div class="score_text">+{{ viewModelInfo.score }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="title">图为预览效果，以实际投效果为准</div>
  </div>
</template>

<script>
import dayjs from "dayjs";
import duration from "dayjs/plugin/duration";
dayjs.extend(duration);
export default {
  name: "phone_freetrial",
  props: {
    ruleForm: {
      type: Object,
      default: () => ({}),
    },
    templateObj: {
      type: Object,
      default: () => ({}),
    },
  },
  watch: {},
  computed: {
    formattedTime() {
      // 直接格式化为 mm:ss，不考虑小时
      const d = dayjs.duration(this.viewModelInfo.validTime, "seconds");
      const minutes = d.minutes() + d.hours() * 60; // 将小时转为分钟
      const seconds = d.seconds();
      return `${minutes.toString().padStart(2, "0")}:${seconds
        .toString()
        .padStart(2, "0")}`;
    },
    progressBarStyle1() {
      const { progressBarColor } = this.viewModelInfo;
      return {
        background: this.hexToRgba(progressBarColor, 0.4),
      };
    },
    progressBarStyle2() {
      const { progressBarColor } = this.viewModelInfo;
      return {
        background: this.hexToRgba(progressBarColor),
      };
    },
    musicImgUrl() {
      const { bgMusicBtnColor, isMusicOpen } = this.viewModelInfo;
      const type = bgMusicBtnColor === "2" ? "2" : "1";
      const status = isMusicOpen ? "" : "_prohibited";
      return `https://cdn-image.yucrm.cn/images/tb/funGamesImg/music${type}${status}.png`;
    },
    activityBgImg() {
      return {
        backgroundImage: `url(${this.viewModelInfo.activityBgImg})`,
        backgroundSize: "100% 100%",
        backgroundPosition: "center center",
        backgroundRepeat: "no-repeat",
        borderRadius: "8px",
      };
    },
    gameGuideAreaStyle() {
      return {
        backgroundImage: `url(${this.viewModelInfo.holeImg})`,
        backgroundSize: "100% 100%",
        backgroundPosition: "center center",
        backgroundRepeat: "no-repeat",
      };
    },
    grabPrizeBtnBg() {
      return {
        backgroundImage: `url(${this.viewModelInfo.btnBgImg})`,
        backgroundSize: "100% 100%",
        backgroundPosition: "center center",
        backgroundRepeat: "no-repeat",
        color: this.viewModelInfo.btnFontColor,
      };
    },
    viewModelInfo() {
      const form = this.ruleForm || {};
      const configJson = JSON.parse(form.configJson || "{}");
      const temJson = JSON.parse(this.templateObj.configJson || "{}");
      return {
        // 颜色与样式配置字段映射
        btnFontColor: form.rgb ? form.rgb : this.templateObj.rgb, // 按钮字体颜色
        progressBarColor: form.rgb2 ? form.rgb2 : this.templateObj.rgb2, // 进度条颜色
        bgMusicBtnColor: form.rgb3 ? form.rgb3 : this.templateObj.rgb3, // 背景音乐按钮
        // 图片资源字段映射
        activityBgImg: form.url ? form.url : this.templateObj.url, // 活动背景图
        btnBgImg: form.url5 ? form.url5 : this.templateObj.url5, // 按钮背景图
        gameCoverImg: configJson.url6 ? configJson.url6 : temJson.url6, // 游戏封面图
        previewImg: form.imageUrl, // B端预览图
        holeImg: form.url2 ? form.url2 : this.templateObj.url2, // 游戏指引图
        brandLogoImg: form.logoUrl, // 品牌logo
        validTime: form.gameTime, // 倒计时间
        score: form.gameScorePer, // 每次点击得分
        isMusicOpen: form.musicOpen, //是否开启音乐配置
      };
    },
  },
  data() {
    return {};
  },
  methods: {
    // 十六进制转RGBA的工具函数
    hexToRgba(hex, opacity = 1) {
      // 移除 # 号
      if (hex) {
        hex = hex.replace("#", "");
        // 解析RGB值
        const r = parseInt(hex.substring(0, 2), 16);
        const g = parseInt(hex.substring(2, 4), 16);
        const b = parseInt(hex.substring(4, 6), 16);
        // 返回RGBA格式
        return `rgba(${r}, ${g}, ${b}, ${opacity})`;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.preview_box {
  width: 316px;
  height: 640px;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.phone_wrap {
  width: 316px;
  height: 625px;
  border-radius: 8px;
  background: #ffffff33;
  box-shadow: 0px 4px 20px 0px #120a3c26;
  border: 1px solid #ffffff;
  padding: 8px;
  background-color: #ffffff;
  overflow: hidden;
  overflow-y: auto;
  &::-webkit-scrollbar {
    display: none;
  }
  .phone {
    width: 300px;
    // height: 625px;
    height: 735px;
    display: flex;
    flex-direction: column;
    align-items: center;
    .header {
      width: 300px;
      z-index: 2;
    }
    .intermediate {
      width: 100%;
      height: 100px;
      position: relative;
      .music_box {
        position: absolute;
        top: 10px;
        left: 10px;
        width: 25px;
        height: 25px;
      }
      .content {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        .logo_box {
          width: 80px;
          height: 40px;
        }
        .progressBar_box {
          margin-top: 13px;
          position: relative;
          width: 200px;
          height: 42px;

          .progressBar {
            position: absolute;
            top: 6px;
            left: 0;
            width: 200px;
            height: 16px;
            border-radius: 12px;
            border: 1px solid #ffffff;
            padding: 1px;
            .progress {
              width: 100px;
              height: 13px;
              border-radius: 12px;
            }
          }
          .gift_box {
            position: absolute;
            top: 0;
            right: 0;
            width: 50px;
            height: 42px;
            .gift {
              display: flex;
              flex-direction: column;
              align-items: end;
              justify-content: center;
              .giftImage {
                width: 25px;
                height: 25px;
              }
              .gift_text {
                margin-top: 3px;
                font-size: 10px;
                color: #000000;
              }
            }
          }
        }
      }
    }
    .gameContent {
      width: 300px;
      height: 500px;
      position: relative;
      .gameGuideArea {
        width: 300px;
        height: 80px;
        display: flex;
        justify-content: center;
        .gameGuideAreaBg {
          width: 250px;
          height: 74px;
          .showPrize {
            width: 116px;
            height: 30px;
            margin-top: 12px;
            margin-left: 20px;
          }
          .countDown {
            width: 100%;
            height: 30px;
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 15px;
            color: rgba(0, 0, 0, 0.6);
          }
        }
      }
      .grabPrize_box {
        position: absolute;
        top: 30px;
        width: 300px;
        height: 400px;
        .grabPrizeImage {
          margin-top: 44px;
          margin-left: 20px;
          width: 260px;
          height: 355px;
        }
      }
      .grabPrize_btn {
        width: 135px;
        height: 50px;
        position: absolute;
        text-align: center;
        left: 50%;
        transform: translateX(-50%);
        bottom: 0;
        font-size: 25px;
        line-height: 45px;
      }

      .score_box {
        position: absolute;
        width: 120px;
        left: 50px;
        top: 130px;
        font-family: DIN, DIN;
        font-weight: 600;
        font-size: 24px;
        line-height: 22px;
        -webkit-text-stroke: 1px #ffffff;
        text-align: center;
        font-style: italic;
        text-transform: none;
        background: linear-gradient(
          267.83280284203deg,
          #ffd65a 0%,
          #ff8737 100%
        );
        -webkit-text-stroke: 1px #ffffff;
        -webkit-background-clip: text;
        background-clip: text;
        color: transparent;
        .score_text {
          width: 120px;
          padding-right: 2px;
          display: flex;
          align-items: center;
          justify-content: flex-end;
        }
      }
    }
  }
}
.title {
  margin-top: 20px;
  font-size: 14px;
  font-weight: 400;
  color: #999999;
  line-height: 14px;
  text-align: center;
}
</style>
